export default class CarouselGeneric {
  domRoot: HTMLElement;
  params: any;
  hashes: any;
  prevHash: null;
  galleryContainer: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = params;
    this.hashes = params.hashes;
    this.prevHash = null;
    this.galleryContainer = domRoot.querySelector('.inner-carousel');
    this.init();
  }

  init() {
    var self = this;
    this.domRoot.addEventListener("click", function(e) {
      console.log(e.target.className)
      if (e.target.classList.contains('arrow')) {
        var parental = self.domRoot.querySelector('.active-item') as HTMLElement;
        var prevPage = parental.previousElementSibling ? parental.previousElementSibling : self.galleryContainer.children[self.galleryContainer.children.length - 1];
        var nextPage = parental.nextElementSibling ? parental.nextElementSibling : self.galleryContainer.children[0];

        if (e.target.classList.contains('left-arrow')) {
          prevPage
          prevPage.classList.remove("hideright", "hideleft", "unfocusable");
          prevPage.classList.add("showright", "active-item");
          prevPage.setAttribute("aria-hidden", "false");
          parental.classList.remove("showright", "showleft", "active-item");
          parental.classList.add("hideright");
          parental.setAttribute("aria-hidden", "true");

        } else if (e.target.classList.contains('right-arrow')) {
          nextPage.classList.remove("hideright", "hideleft", "unfocusable");
          nextPage.classList.add("showleft", "active-item");
          nextPage.setAttribute("aria-hidden", "false");
          parental.classList.remove("showright", "showleft", "active-item");
          parental.classList.add("hideleft");
          parental.setAttribute("aria-hidden", "true");
        }
      }

      setTimeout(() => {
        parental.classList.add("unfocusable");
      }, 300)
    });
  }
}
